import React from 'react';
import { ShoppingCartPageItemModel } from './Model';
import delIcon from './images/icon-delete.svg';
import {
  getTextStatic,
  getdivClassStatic as availabilityClassName,
} from '../../Basepage/parts/Availability';
import { PageMode } from '../../Basepage/parts/Definitions';
import DetailsContainer from './DetailsContainer';
import { replaceAllComplex, umcodeURL } from '../../../../../mol_function';

interface ShoppingCartItemProps {
  index: number;
  mode: PageMode;
  item: ShoppingCartPageItemModel;
  domainPrefix: string;
}
export default class ShoppingCartItem extends React.Component<ShoppingCartItemProps> {
  render() {
    {
      let className: string = this.props.index % 2 == 0 ? 'rowEven' : 'rowOdd';
      if (this.props.mode == PageMode.Mobile) {
        className = className + ' mobileSlit';
      }

      let itemCountDiv = (
        <React.Fragment>
          <input
            className="cssButton submit_button button  button_update_cart_v"
            onMouseOver={(e) => {
              let target: any = e.target;
              target.className =
                'cssButtonHover  button_update_cart_v button_update_cart_vHover';
            }}
            onMouseOut={(e) => {
              let target: any = e.target;
              target.className =
                'cssButton submit_button button  button_update_cart_v';
            }}
            type="submit"
            value=""
          />
        </React.Fragment>
      );
      let delSnipped = (
        <a
          onClick={() => {
            /*
            let itemjson = JSON.stringify([
              {
                product: this.props.item.id,
                quantity: 0,
              },
            ]);
            */
            debugger;
            let item = {};
            item[this.props.item.id] = { quantity: 0 };
            let itemjson = JSON.stringify(item);
            window.historyHelper.memory.push(
              '/shopping_cart/?update=' + encodeURI(itemjson),
            );
          }}
        >
          <img
            src={delIcon}
            alt="Löschen"
            title=" Löschen "
            width="20"
            height="21"
          />
        </a>
      );

      let productsDeliveryDate: Date | undefined = undefined;
      if (this.props.item.release_date) {
        productsDeliveryDate = new Date(
          Date.parse(this.props.item.release_date),
        );
      }

      let real_lz: number | undefined = undefined;
      if (this.props.item.real_lz != undefined) {
        try {
          real_lz = Number.parseInt(this.props.item.real_lz);
        } catch {}
      }

      let productUrl = umcodeURL(this.props.item.productUrl);

      let productName = replaceAllComplex(this.props.item.name, [
        { s: "\\'", r: "'" },
      ]);

      return (
        <React.Fragment key={'cartItemsContainer' + this.props.index}>
          <tr
            className={className}
            key={'cartItems' + this.props.index}
            id={'cartItems' + this.props.index}
          >
            <td className="cartQuantity">
              <input
                type="text"
                name={'cart_quantity_' + this.props.item.id}
                defaultValue={this.props.item.quantity}
                size={4}
              />
              {this.props.mode == PageMode.Mobile ? (
                <React.Fragment>
                  <br />
                  <div className="flex">{itemCountDiv}</div>

                  <div className="flex">{delSnipped}</div>
                </React.Fragment>
              ) : null}
            </td>
            {this.props.mode != PageMode.Mobile ? (
              <React.Fragment>
                <td className="cartQuantityUpdate">{itemCountDiv}</td>
              </React.Fragment>
            ) : null}

            <td className="cartProductDisplay">
              <a href={productUrl} target="_blank">
                <span id="cartImage" className="back">
                  <img
                    src={
                      'https://media.moluna.de/images/' + this.props.item.image
                    }
                    alt={this.props.item.name}
                    title={this.props.item.name}
                    width="100"
                    height="auto"
                    style={{ maxHeight: '150px' }}
                  />
                </span>
              </a>
              {this.props.mode != PageMode.Mobile ? (
                <div id="cartProdTitle">
                  <a href={productUrl} target="_blank">
                    <span className="cartId">
                      {this.props.item.id} - {this.props.item.ean}
                    </span>

                    <span className="cartTitel">{productName}</span>
                    <span className="cartArt">
                      {this.props.item.Kategorie}{' '}
                      {this.props.item.Medium != undefined
                        ? ' - ' + this.props.item.Medium
                        : null}
                      {this.props.item.Verlag != undefined
                        ? ' - ' + this.props.item.Verlag
                        : null}
                      -
                    </span>
                    {/* 
                    <div className="cartVerfuegbar" id="Availability">
                      <div
                        className={availabilityClassName(
                          this.props.item.Delivery_time,
                        )}
                      >
                        <div id="verfuegbarkeit">
                          {getTextStatic(
                            this.props.item.Delivery_time,
                            productsDeliveryDate,
                            real_lz,
                          )}
                        </div>
                      </div>
                    </div> 
                    */}
                  </a>
                  <DetailsContainer
                    key={'DetailsContainer_' + this.props.index}
                    itemIndex={this.props.index}
                    data={this.props.item.details}
                    productID={this.props.item.id}
                    update={() => {
                      debugger;
                    }}
                    itemTotalCount={this.props.item.quantity}
                  />
                </div>
              ) : null}

              <br className="clearBoth" />
            </td>
            <td>
              {this.props.item.mode != 'libri' ? (
                <>
                  {this.props.item.hasSchnell ? (
                    <>
                      <div id="buy_mode">
                        <input
                          type="radio"
                          name={'cart_mode_' + this.props.item.id}
                          value="schnell"
                          checked={this.props.item.mode == 'schnell'}
                          onChange={(e) => {
                            let item = {};
                            item[this.props.item.id] = { mode: 'schnell' };
                            let itemjson = JSON.stringify(item);
                            window.historyHelper.memory.push(
                              '/shopping_cart/?update=' + encodeURI(itemjson),
                            );
                          }}
                        />
                        <label>schnellstmöglich</label>
                        <br />
                        <input
                          type="radio"
                          name={'cart_mode_' + this.props.item.id}
                          value="standart"
                          checked={this.props.item.mode == 'standart'}
                          onChange={(e) => {
                            let item = {};
                            item[this.props.item.id] = { mode: 'standart' };
                            let itemjson = JSON.stringify(item);
                            window.historyHelper.memory.push(
                              '/shopping_cart/?update=' + encodeURI(itemjson),
                            );
                          }}
                        />
                        <label>günstigst</label>
                      </div>
                    </>
                  ) : (
                    <input
                      type="hidden"
                      name={'cart_mode_' + this.props.item.id}
                      value="standart"
                    />
                  )}
                </>
              ) : (
                <input
                  type="hidden"
                  name={'cart_mode_' + this.props.item.id}
                  value="libri"
                />
              )}
            </td>
            {this.props.mode != PageMode.Mobile ? (
              <React.Fragment>
                <td className="cartUnitDisplay">
                  {this.props.item.item_price_netto
                    .toFixed(2)
                    .replace('.', ',')}{' '}
                  €
                  {this.props.item.rabatt != undefined ? (
                    <>
                      <br />
                      <span style={{ color: '#737373', fontSize: '14px' }}>
                        {this.props.item.rabatt.toFixed(2)} %
                      </span>
                    </>
                  ) : (
                    ''
                  )}
                </td>
                <td className="cartUnitDisplay">
                  {this.props.item.item_tax.toFixed(2).replace('.', ',')} €
                </td>
              </React.Fragment>
            ) : null}
            <td className="cartTotalDisplay">
              {this.props.item.final_price_netto.toFixed(2).replace('.', ',')} €
            </td>
            {this.props.mode != PageMode.Mobile ? (
              <React.Fragment>
                <td className="cartRemoveItemDisplay">{delSnipped}</td>
              </React.Fragment>
            ) : null}
          </tr>
          {this.props.mode == PageMode.Mobile ? (
            <tr
              key={'cartItemsMobile' + this.props.index}
              id={'cartItemsMobile' + this.props.index}
            >
              <td colSpan={3}>
                <div id="cartProdTitle">
                  <a href={productUrl} target="_blank">
                    <span className="cartTitel">{productName}</span>
                  </a>

                  <span className="cartArt">
                    {this.props.item.id} {this.props.item.Kategorie}{' '}
                    {this.props.item.Medium != undefined
                      ? ' - ' + this.props.item.Medium
                      : null}
                    {this.props.item.Verlag != undefined
                      ? ' - ' + this.props.item.Verlag
                      : null}
                    -
                  </span>
                  <div className="cartVerfuegbar" id="Availability">
                    <div
                      className={availabilityClassName(
                        this.props.item.Delivery_time,
                      )}
                    >
                      <div id="verfuegbarkeit">
                        {getTextStatic(
                          this.props.item.Delivery_time,
                          productsDeliveryDate,
                          real_lz,
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          ) : null}
        </React.Fragment>
      );
    }
  }
}
